module.exports = __webpack_public_path__ + "igdcb-c168ec89.webp";